import getSliderTrackers from "./getSliderTrackers";
import getTranslateParams from "./getTranslateParams";
export default (rangeSelectorRef) => {
    var _a;
    const element = (_a = rangeSelectorRef.current) === null || _a === void 0 ? void 0 : _a.instance.element();
    const { leftTracker } = getSliderTrackers(rangeSelectorRef);
    const areaTracker = element === null || element === void 0 ? void 0 : element.querySelector(".dxrs-trackers > .area-tracker");
    if (!leftTracker || !areaTracker)
        return { minX: 0, maxX: 0, y: 0, width: 0 };
    const { x, y } = getTranslateParams(leftTracker);
    const { width } = areaTracker.getBoundingClientRect();
    return { minX: x, maxX: width + x, y, width };
};
